/*
 * Branded carousel for the "Based on your taste" (related) and
 * "Recently viewed" product sliders.
 *
 * Adds overlay side arrows + terracotta dot pagination that page by the
 * number of fully visible slides. Matches the complementary slider style.
 *
 * Usage: markup needs .related-products-slider > .related-products-slider__viewport
 *        > .related-products-slider__track > .related-products-slider__slide,
 *        plus an empty .related-products-slider__dots container. Arrows are
 *        created here. Call window.initRelatedCarousel(rootEl) after dynamic
 *        renders; it auto-runs on DOM ready and is idempotent.
 */
(function () {
  function arrow(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'related-products-slider__arrow related-products-slider__arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      (dir === 'prev'
        ? '<polyline points="15 18 9 12 15 6"></polyline>'
        : '<polyline points="9 6 15 12 9 18"></polyline>') +
      '</svg>';
    return btn;
  }

  function init(slider) {
    if (!slider || slider._rcInit) return;
    var viewport = slider.querySelector('.related-products-slider__viewport');
    var track = slider.querySelector('.related-products-slider__track');
    if (!viewport || !track) return;
    slider._rcInit = true;

    var dotsBox = slider.querySelector('.related-products-slider__dots');
    var prevBtn = arrow('prev');
    var nextBtn = arrow('next');
    slider.appendChild(prevBtn);
    slider.appendChild(nextBtn);

    var dots = [];

    function slides() {
      return track.querySelectorAll('.related-products-slider__slide');
    }

    function slidesPerView(list) {
      if (!list.length) return 1;
      var first = list[0].getBoundingClientRect().width;
      if (!(first > 8)) return 1;
      var gap = parseFloat(getComputedStyle(track).gap) || parseFloat(getComputedStyle(track).columnGap) || 0;
      var n = Math.round((viewport.clientWidth + gap) / (first + gap));
      return Math.max(1, Math.min(list.length, n));
    }

    function activePage() {
      var list = slides();
      var spv = slider._spv || 1;
      var pc = slider._pc || 1;
      if (!list.length || pc < 1) return 0;
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (maxScroll > 1 && viewport.scrollLeft >= maxScroll - 4) return pc - 1;
      var left = viewport.getBoundingClientRect().left;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i].getBoundingClientRect().left - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return Math.max(0, Math.min(pc - 1, Math.floor(best / spv)));
    }

    function goToPage(p) {
      var list = slides();
      var spv = slider._spv || 1;
      if (!list.length) return;
      var idx = Math.min(p * spv, list.length - 1);
      viewport.scrollTo({ left: Math.max(0, Math.round(list[idx].offsetLeft)), behavior: 'smooth' });
      setTimeout(sync, 400);
    }

    function syncArrows() {
      var pc = slider._pc || 0;
      var ap = activePage();
      // Mark arrows scrollable-in-direction; CSS reveals them on slider hover.
      prevBtn.classList.toggle('is-visible', pc > 1 && ap > 0);
      nextBtn.classList.toggle('is-visible', pc > 1 && ap < pc - 1);
    }

    function sync() {
      var ap = activePage();
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === ap);
      syncArrows();
    }

    function clearDots() {
      // Keep the (reserved) container in flow so hiding dots never shifts the
      // page; just remove the dots themselves.
      if (dotsBox) dotsBox.innerHTML = '';
      dots = [];
    }

    function rebuild() {
      var list = slides();
      if (list.length <= 1) {
        slider._pc = 0;
        slider._spv = 1;
        clearDots();
        syncArrows();
        return;
      }
      var spv = slidesPerView(list);
      var pc = Math.ceil(list.length / spv);
      slider._spv = spv;
      slider._pc = pc;
      if (pc <= 1) {
        clearDots();
        syncArrows();
        return;
      }
      if (dotsBox) {
        dotsBox.innerHTML = '';
        dots = [];
        for (var i = 0; i < pc; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'related-products-slider__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + pc);
          dot.dataset.page = String(i);
          dotsBox.appendChild(dot);
          dots.push(dot);
        }
      }
      sync();
    }

    prevBtn.addEventListener('click', function () {
      var ap = activePage();
      if (ap > 0) goToPage(ap - 1);
    });
    nextBtn.addEventListener('click', function () {
      var pc = slider._pc || 1;
      var ap = activePage();
      if (ap < pc - 1) goToPage(ap + 1);
    });
    if (dotsBox) {
      dotsBox.addEventListener('click', function (e) {
        var dot = e.target.closest('.related-products-slider__dot');
        if (!dot) return;
        var p = parseInt(dot.dataset.page, 10);
        if (!isNaN(p)) goToPage(p);
      });
    }

    var st;
    viewport.addEventListener(
      'scroll',
      function () {
        clearTimeout(st);
        st = setTimeout(sync, 60);
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        rebuild();
      });
      ro.observe(viewport);
      ro.observe(track);
    } else {
      window.addEventListener('resize', rebuild);
    }

    // On a fresh load (or a back/forward bfcache restore) the browser restores
    // the viewport's previous horizontal scroll, and iOS Safari re-applies
    // scroll-snap onto an arbitrary card — so the row would open mid-way (e.g.
    // "page 7") instead of the first product. Force it back to the start
    // instantly (scroll-behavior:auto avoids animating the correction), then
    // re-sync the dots. Mirrors the home-page featured collection fix.
    function resetStart() {
      requestAnimationFrame(function () {
        if (viewport.scrollLeft === 0) return;
        var prev = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = 0;
        viewport.style.scrollBehavior = prev;
        sync();
      });
    }
    slider._rcReset = resetStart;

    // Allow re-init callers (e.g. recently-viewed renders slides after DOM
    // ready) to rebuild dots/arrows for newly added slides.
    slider._rcRebuild = function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(rebuild);
      });
    };
    slider._rcRebuild();
    resetStart();
  }

  window.initRelatedCarousel = function (root) {
    (root || document).querySelectorAll('.related-products-slider').forEach(function (slider) {
      if (slider._rcInit) {
        if (typeof slider._rcRebuild === 'function') slider._rcRebuild();
      } else {
        init(slider);
      }
    });
  };

  function boot() {
    window.initRelatedCarousel(document);
  }

  // Reset every row to its first product on load and on bfcache restore, so a
  // back/forward navigation never re-opens a row scrolled to the middle/end.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.related-products-slider').forEach(function (slider) {
      if (typeof slider._rcReset === 'function') slider._rcReset();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
